import { ResponsivePie } from '@nivo/pie';
import { ResponsiveBar } from '@nivo/bar';
import { ResponsiveLineCanvas } from '@nivo/line';

const Report32OnlineInfo = (props) => {
  const { responseData } = props;
  const margin = { top: 20, right: 100, bottom: 100, left: 100 };
  const styles = {
    fontFamily: 'consolas, sans-serif',
    textAlign: 'center',
    position: 'relative',
    height: 400,
    marginBottom: '10rem',
  };

  const legends = [
    {
      anchor: 'bottom',
      direction: 'row',
      justify: false,
      translateX: 0,
      translateY: 80,
      itemsSpacing: 25,
      itemWidth: 100,
      itemHeight: 0,
      itemDirection: 'left-to-right',
      itemOpacity: 0.85,
      itemTextColor: '#000000',
      symbolSize: 20,
      effects: [
        {
          on: 'hover',
          style: {
            itemOpacity: 1,
          },
        },
      ],
    },
  ];

  return (
    <div className="row mt-3">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12" style={styles}>
                <h2>Evolutivo de residuos producidos (Tn)</h2>
                {responseData?.onlineInfo?.evolutivoTipoResiduo ? (
                  <ResponsiveLineCanvas
                    data={responseData?.onlineInfo?.evolutivoTipoResiduo}
                    margin={{ top: 50, right: 80, bottom: 100, left: 80 }}
                    colors={(d) => d.color}
                    borderColor={{
                      from: 'color',
                      modifiers: [['darker', 1.6]],
                    }}
                    axisBottom={{
                      tickRotation: -45,
                      tickSize: 0,
                      tickPadding: 12,
                    }}
                    axisLeft={{
                      tickSize: 5,
                      tickRotation: 0,
                    }}
                    legends={[
                      {
                        anchor: 'top',
                        direction: 'row',
                        justify: false,
                        translateX: 0,
                        translateY: -30,
                        itemsSpacing: 25,
                        itemWidth: 100,
                        itemHeight: 0,
                        itemDirection: 'left-to-right',
                        itemOpacity: 0.85,
                        itemTextColor: '#000000',
                        symbolSize: 20,
                        effects: [
                          {
                            on: 'hover',
                            style: {
                              itemOpacity: 1,
                            },
                          },
                        ],
                      },
                    ]}
                  />
                ) : (
                  <h4 className="mt-4">No hay datos disponibles</h4>
                )}
              </div>
              <div className="col-12 col-lg-6" style={styles}>
                <h2>Porcentaje valorizable (%)</h2>
                {responseData?.onlineInfo?.percentage ? (
                  <ResponsivePie
                    margin={margin}
                    data={responseData.onlineInfo.percentage}
                    padAngle={1}
                    colors={(d) => d?.data?.color}
                    enableArcLinkLabels={false}
                    legends={legends}
                  />
                ) : (
                  <h4 className="mt-4">No hay datos disponibles</h4>
                )}
              </div>
              <div className="col-12 col-lg-6" style={styles}>
                <h2>Total peligrosos (Tn)</h2>
                {responseData?.onlineInfo?.dangerousTotal ? (
                  <ResponsivePie
                    margin={margin}
                    data={responseData.onlineInfo.dangerousTotal}
                    padAngle={1}
                    colors={(d) => d?.data?.color}
                    enableArcLinkLabels={false}
                    legends={legends}
                  />
                ) : (
                  <h4 className="mt-4">No hay datos disponibles</h4>
                )}
              </div>
              <div className="col-12 col-lg-6" style={styles}>
                <h2>Total RCD (Tn)</h2>
                {responseData?.onlineInfo?.rcdTotal ? (
                  <ResponsivePie
                    margin={margin}
                    data={responseData?.onlineInfo?.rcdTotal}
                    padAngle={1}
                    colors={(d) => d?.data?.color}
                    enableArcLinkLabels={false}
                    legends={legends}
                  />
                ) : (
                  <h4 className="mt-4">No hay datos disponibles</h4>
                )}
              </div>
              <div className="col-12 col-lg-6" style={styles}>
                <h2>Total No Peligrosos (Tn)</h2>
                {responseData?.onlineInfo?.noDangerousTotal ? (
                  <ResponsivePie
                    margin={margin}
                    data={responseData?.onlineInfo?.noDangerousTotal}
                    padAngle={1}
                    colors={(d) => d?.data?.color}
                    enableArcLinkLabels={false}
                    legends={legends}
                  />
                ) : (
                  <h4 className="mt-4">No hay datos disponibles</h4>
                )}
              </div>
              <div
                className="col-12"
                style={{
                  fontFamily: 'consolas, sans-serif',
                  textAlign: 'center',
                  position: 'relative',
                  height:
                    150 +
                    (responseData?.onlineInfo?.totalResiduosPorObra?.length || 1) * 15,
                  marginBottom: '10rem',
                }}
              >
                <h2>Total Residuos (Tn)</h2>
                {responseData?.onlineInfo?.totalResiduosPorObra ? (
                  <ResponsiveBar
                    margin={{ top: 50, right: 80, bottom: 100, left: 300 }}
                    data={responseData?.onlineInfo?.totalResiduosPorObra}
                    padAngle={1}
                    colors={(d) => d?.data?.color}
                    layout="horizontal"
                    labelSkipWidth={40}
                    labelTextColor="#ffffff"
                    valueScale={{ type: 'symlog' }}
                    axisBottom={{
                      tickRotation: -45,
                      tickSize: 0,
                      tickPadding: 12,
                    }}
                  />
                ) : (
                  <h4 className="mt-4">No hay datos disponibles</h4>
                )}
              </div>
              <div
                className="col-12"
                style={{
                  fontFamily: 'consolas, sans-serif',
                  textAlign: 'center',
                  position: 'relative',
                  height:
                    150 +
                    (responseData?.onlineInfo
                      ?.totalResiduosPorObraValorizadosNoValorizados?.length ||
                      1) *
                      30,
                  marginBottom: '10rem',
                }}
              >
                <h2>Total Residuos (Tn)</h2>
                {responseData?.onlineInfo
                  ?.totalResiduosPorObraValorizadosNoValorizados ? (
                  <ResponsiveBar
                    margin={{ top: 50, right: 80, bottom: 100, left: 300 }}
                    data={
                      responseData?.onlineInfo
                        ?.totalResiduosPorObraValorizadosNoValorizados
                    }
                    indexBy="plant"
                    keys={['valorizados', 'no valorizados']}
                    padAngle={1}
                    colors={({ id, data }) => data[`${id}Color`]}
                    layout="horizontal"
                    labelSkipWidth={40}
                    labelTextColor="#ffffff"
                    valueScale={{ type: 'symlog' }}
                    groupMode="grouped"
                    legends={[
                      {
                        anchor: 'top',
                        direction: 'row',
                        justify: false,
                        translateX: 0,
                        translateY: -30,
                        itemsSpacing: 25,
                        itemWidth: 100,
                        itemHeight: 0,
                        itemDirection: 'left-to-right',
                        itemOpacity: 0.85,
                        itemTextColor: '#000000',
                        symbolSize: 20,
                        effects: [
                          {
                            on: 'hover',
                            style: {
                              itemOpacity: 1,
                            },
                          },
                        ],
                      },
                    ]}
                    axisLeft={{
                      tickSize: 5,
                      tickRotation: 0,
                    }}
                    axisBottom={{
                      tickRotation: -45,
                      tickSize: 0,
                      tickPadding: 12,
                    }}
                  />
                ) : (
                  <h4 className="mt-4">No hay datos disponibles</h4>
                )}
              </div>
              <div
                className="col-12"
                style={{
                  fontFamily: 'consolas, sans-serif',
                  textAlign: 'center',
                  position: 'relative',
                  height:
                    200 +
                    (responseData?.onlineInfo
                      ?.totalResiduosPorLerValorizadosNoValorizados?.length ||
                      1) *
                      25,
                  marginBottom: '10rem',
                }}
              >
                <h2>Residuos valorizados por LER (Tn)</h2>
                {responseData?.onlineInfo
                  ?.totalResiduosPorLerValorizadosNoValorizados ? (
                  <ResponsiveBar
                    margin={{ top: 50, right: 80, bottom: 100, left: 80 }}
                    data={
                      responseData?.onlineInfo
                        ?.totalResiduosPorLerValorizadosNoValorizados
                    }
                    indexBy="lerCode"
                    keys={['valorizados', 'no valorizados']}
                    padAngle={1}
                    colors={({ id, data }) => data[`${id}Color`]}
                    layout="horizontal"
                    labelSkipWidth={40}
                    labelTextColor="#ffffff"
                    valueScale={{ type: 'symlog' }}
                    groupMode="grouped"
                    legends={[
                      {
                        anchor: 'top',
                        direction: 'row',
                        justify: false,
                        translateX: 0,
                        translateY: -30,
                        itemsSpacing: 25,
                        itemWidth: 100,
                        itemHeight: 0,
                        itemDirection: 'left-to-right',
                        itemOpacity: 0.85,
                        itemTextColor: '#000000',
                        symbolSize: 20,
                        effects: [
                          {
                            on: 'hover',
                            style: {
                              itemOpacity: 1,
                            },
                          },
                        ],
                      },
                    ]}
                    axisBottom={{
                      tickRotation: -45,
                      tickSize: 0,
                      tickPadding: 12,
                    }}
                  />
                ) : (
                  <h4 className="mt-4">No hay datos disponibles</h4>
                )}
              </div>
              <div className="col-12 col-lg-6" style={styles}>
                <h2>Consumo agua por origen (m3)</h2>
                {responseData?.onlineInfo?.waterUse ? (
                  <ResponsivePie
                    margin={margin}
                    data={responseData.onlineInfo.waterUse}
                    padAngle={1}
                    colors={(d) => d?.data?.color}
                    enableArcLinkLabels={false}
                    legends={legends}
                  />
                ) : (
                  <h4 className="mt-4">No hay datos disponibles</h4>
                )}
              </div>
              <div className="col-12 col-lg-6" style={styles}>
                <h2>Restauración paisajística por tipo (m3)</h2>
                {responseData?.onlineInfo?.landscapeRestoration ? (
                  <ResponsivePie
                    margin={margin}
                    data={responseData.onlineInfo.landscapeRestoration}
                    padAngle={1}
                    colors={(d) => d?.data?.color}
                    enableArcLinkLabels={false}
                    legends={legends}
                  />
                ) : (
                  <h4 className="mt-4">No hay datos disponibles</h4>
                )}
              </div>
              <div className="col-12 col-lg-6" style={styles}>
                <h2>Reutilización material (m3)</h2>
                {responseData?.onlineInfo?.naturalResourcesUseReduction ? (
                  <ResponsivePie
                    margin={margin}
                    data={responseData.onlineInfo.naturalResourcesUseReduction}
                    padAngle={1}
                    colors={(d) => d?.data?.color}
                    enableArcLinkLabels={false}
                    legends={legends}
                  />
                ) : (
                  <h4 className="mt-4">No hay datos disponibles</h4>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Report32OnlineInfo;
